export default __webpack_public_path__ + "static/india-c019442ce8cf187ffad57cf9a4b9313a.svg";